import { render } from "./mipres.vue?vue&type=template&id=0007384d&scoped=true"
import script from "./mipres.vue?vue&type=script&lang=js"
export * from "./mipres.vue?vue&type=script&lang=js"

import "./mipres.vue?vue&type=style&index=0&id=0007384d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0007384d"]])

export default __exports__